/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 配信者 (会社) 画像アップロード成功時のレスポンスデータ
 * @export
 * @interface PostDistributorImageSuccessResponseData
 */
export interface PostDistributorImageSuccessResponseData {
    /**
     * サーバーに保存されたファイルの名前
     * @type {string}
     * @memberof PostDistributorImageSuccessResponseData
     */
    imageFileName: string;
    /**
     * s3に保存されたファイルの名前
     * @type {string}
     * @memberof PostDistributorImageSuccessResponseData
     */
    imageFileNameS3: string;
    /**
     * CMYK画像かどうか
     * @type {boolean}
     * @memberof PostDistributorImageSuccessResponseData
     */
    isCMYK: boolean;
}

export function PostDistributorImageSuccessResponseDataFromJSON(json: any): PostDistributorImageSuccessResponseData {
    return PostDistributorImageSuccessResponseDataFromJSONTyped(json, false);
}

export function PostDistributorImageSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostDistributorImageSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imageFileName': json['image_file_name'],
        'imageFileNameS3': json['image_file_name_s3'],
        'isCMYK': json['isCMYK'],
    };
}

export function PostDistributorImageSuccessResponseDataToJSON(value?: PostDistributorImageSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'image_file_name': value.imageFileName,
        'image_file_name_s3': value.imageFileNameS3,
        'isCMYK': value.isCMYK,
    };
}

